<template>
  <layout :lead="leadInfo" :rooftop="rooftopInfo" :welcome-message="welcomeMessage">
    <section class="dealer-content-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6 pl-lg-0">
            <video-box-list :categories="contents.categories || []" />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '@/layouts/default';
import VideoBoxList from '@/components/video-box-list';
import { PAGE_TITLES } from '@/constants';

export default {
  name: 'DealerContent',
  metaInfo: {
    title: PAGE_TITLES['dealer-content'],
  },
  components: {
    Layout,
    VideoBoxList,
  },
  computed: {
    ...mapState(['contents', 'leadInfo', 'rooftopInfo']),
    welcomeMessage() {
      const rooftopMsg = this.rooftopInfo.name ? `${this.rooftopInfo.name} and` : '';
      return `Take a few minutes to learn about ${rooftopMsg} this month's offers.`;
    },
  },
};
</script>
